import React from 'react';
import { AllClaims } from '../../components/admin/AllClaims';

export const Completed = () => {
  // Only show claims with this payment status
  const filterPaymentStatus = "Completed";

  return (
    <>
      <AllClaims filterPaymentStatus={filterPaymentStatus} />
    </>
  );
};
